export default __webpack_public_path__ + "static/media/photo06.f3ecc162.jpg";